import React from "react";
import { MdAdd } from "react-icons/md";
import useLocales from "../../../../../../hooks/useLocales";
import useSettings from "../../../../../../hooks/useSettings";

const AddLocationButton = ({ onClick }) => {
  const { translate } = useLocales();
  const { themeDirection } = useSettings();

  return (
    <div>
      <div className="mt-4 md:w-full lg:w-1/2 border border-gray-300 dark:border-none bg-white dark:bg-dark-secondary rounded md:rounded-[10px] lg:rounded-[10px] p-3 lg:p-[20px] md:mb-[90px] text-left">
        <p className="text-small3 lg:text-small1 mt-2 lg:mt-2.5 text-font_light_color dark:text-color_v2_dark text-start">
          {translate("location.added_any_location")}
        </p>

        <div className="lg:w-[50%] md:w-full">
          <button
            className={`mt-4 rounded-full cursor-pointer flex items-center justify-center p-1 px-[22px] lg:px-[26px] text-white bg-main_color lg:text-small2_b text-small3_b ${
              themeDirection === "ltr" ? "md:px-[24px]" : "md:px-[26px]"
            }`}
            onClick={onClick}
            style={{ whiteSpace: "nowrap" }}
          >
            <div className="flex items-center justify-center">
              <MdAdd className="text-gray-50  lg:text-xl text-lg" />
            </div>
            <span className="gap-2 px- dark:text-color_v2_dark1">
              {translate("location.add_location")}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddLocationButton;
